module.exports = __webpack_public_path__ + "static/media/cashflow-down-btn-selected.72f5845a.svg";